"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoSegmentationDialogView = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var react_1 = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var utils_1 = require("../../utils");
var canvas_paint_1 = require("./components/canvases/canvas-paint");
var canvas_plot_1 = require("./components/canvases/canvas-plot");
var canvas_readonly_area_1 = require("./components/canvases/canvas-readonly-area");
var loading_dots_1 = require("./components/loading-dots");
var toolbar_1 = require("./components/toolbar");
var dialogContentStyle = {
    width: '100%' /* assume maxWidth='lg' */,
    height: '60vh',
    display: 'flex',
    flexDirection: 'row'
};
var ImgCroppedWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  flex-grow: 1;\n  flex-shrink: 1;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  flex-grow: 1;\n  flex-shrink: 1;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var ToolbarWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  flex-grow: 0;\n  flex-shrink: 0;\n  padding: 10px;\n"], ["\n  flex-grow: 0;\n  flex-shrink: 0;\n  padding: 10px;\n"])));
var RelativeWrapper = styled_components_1.default.div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n"], ["\n  position: relative;\n  width: 100%;\n  height: 100%;\n"])));
var AbsoluteWrapper = styled_components_1.default.div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n"])));
var AbsoluteWrapperZ1 = (0, styled_components_1.default)(AbsoluteWrapper)(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  z-index: 1;\n"], ["\n  z-index: 1;\n"])));
var SelectDisabledDiv = styled_components_1.default.div(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  user-select: none;\n  -webkit-touch-callout: none;\n"], ["\n  user-select: none;\n  -webkit-touch-callout: none;\n"])));
var useClientRect = function () {
    var _a = tslib_1.__read((0, react_1.useState)((0, utils_1.IRect)()), 2), rect = _a[0], setRect = _a[1];
    var ref = react_1.default.useCallback(function (node) {
        if (node !== null) {
            var rect_1 = node.getBoundingClientRect();
            setRect((0, utils_1.IRect)({
                width: rect_1.width,
                height: rect_1.height,
                top: rect_1.top,
                left: rect_1.left
            }));
        }
    }, []);
    return [rect, ref];
};
exports.AutoSegmentationDialogView = (0, react_1.memo)(function (_a) {
    var open = _a.open, onSaveClick = _a.onSaveClick, onDiscardClick = _a.onDiscardClick, onButtonClick = _a.onButtonClick, cropRectRelative = _a.cropRectRelative, croppedRectAspectRatio = _a.croppedRectAspectRatio, imgSrc = _a.imgSrc, positivePointsRelative = _a.positivePointsRelative, negativePointsRelative = _a.negativePointsRelative, cursorTypeOnCanvas = _a.cursorTypeOnCanvas, plotMode = _a.plotMode, onPlotRelative = _a.onPlotRelative, bitMatrix = _a.bitMatrix, readonlyArea = _a.readonlyArea;
    var _b = tslib_1.__read(useClientRect(), 2), rect = _b[0], ref = _b[1];
    var canvasRectSize = (0, react_1.useMemo)(function () {
        return (0, utils_1.roundRectSizeToInt)((0, utils_1.toInnerRectSizeKeepingAspectRatio)((0, utils_1.IRectSize)(rect), croppedRectAspectRatio));
    }, [croppedRectAspectRatio, rect]);
    var innerRectStyle = (0, react_1.useMemo)(function () { return ({
        width: "".concat(canvasRectSize.width, "px"),
        height: "".concat(canvasRectSize.height, "px")
    }); }, [canvasRectSize]);
    var onPlot = (0, react_1.useCallback)(function (pos) {
        onPlotRelative(pos.withMutations(function (p) {
            return p
                .update('x', function (x) { return x / canvasRectSize.width; })
                .update('y', function (y) { return y / canvasRectSize.height; });
        }));
    }, [onPlotRelative, canvasRectSize]);
    var positivePointsOnCanvas = (0, react_1.useMemo)(function () {
        return positivePointsRelative.map(function (point) {
            return point.withMutations(function (p) {
                return p
                    .update('x', function (x) { return x * canvasRectSize.width; })
                    .update('y', function (y) { return y * canvasRectSize.height; });
            });
        });
    }, [positivePointsRelative, canvasRectSize]);
    var negativePointsOnCanvas = (0, react_1.useMemo)(function () {
        return negativePointsRelative.map(function (point) {
            return point.withMutations(function (p) {
                return p
                    .update('x', function (x) { return x * canvasRectSize.width; })
                    .update('y', function (y) { return y * canvasRectSize.height; });
            });
        });
    }, [negativePointsRelative, canvasRectSize]);
    return (react_1.default.createElement(core_1.Dialog, { fullWidth: true, maxWidth: 'lg', disableEscapeKeyDown: true, disableBackdropClick: true, open: open },
        react_1.default.createElement(core_1.DialogTitle, null,
            "Running Auto Segmentation ",
            react_1.default.createElement(loading_dots_1.LoadingDots, null)),
        react_1.default.createElement(core_1.DialogContent, { style: dialogContentStyle },
            react_1.default.createElement(ImgCroppedWrapper, { ref: ref },
                react_1.default.createElement(SelectDisabledDiv, { style: innerRectStyle },
                    react_1.default.createElement(RelativeWrapper, null,
                        react_1.default.createElement(AbsoluteWrapper, null,
                            react_1.default.createElement(utils_1.ImgCropped, { src: imgSrc, cropRectRelative: cropRectRelative })),
                        react_1.default.createElement(AbsoluteWrapperZ1, null,
                            react_1.default.createElement(canvas_plot_1.CanvasPlotPoints, { canvasSize: canvasRectSize, positivePoints: positivePointsOnCanvas, negativePoints: negativePointsOnCanvas, cursorType: cursorTypeOnCanvas, onPlot: onPlot })),
                        react_1.default.createElement(AbsoluteWrapper, null,
                            react_1.default.createElement(canvas_paint_1.CanvasPaint, { canvasSize: canvasRectSize, bitMatrix: bitMatrix })),
                        react_1.default.createElement(AbsoluteWrapper, null,
                            react_1.default.createElement(canvas_readonly_area_1.CanvasReadonlyArea, { canvasSize: canvasRectSize, readonlyArea: readonlyArea }))))),
            react_1.default.createElement(ToolbarWrapper, null,
                react_1.default.createElement(toolbar_1.AutoSegmentationToolbar, { onButtonClick: onButtonClick, plotMode: plotMode }))),
        react_1.default.createElement(core_1.DialogActions, null,
            react_1.default.createElement(core_1.Button, { onClick: onDiscardClick, color: 'default' }, "Discard"),
            react_1.default.createElement(core_1.Button, { onClick: onSaveClick, color: 'primary' }, "Save"))));
});
exports.AutoSegmentationDialogView.displayName = 'AutoSegmentationDialogView';
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
